import { createContext, useContext, useState, useEffect } from 'react';

const ViewModeContext = createContext();

export function ViewModeProvider({ children }) {
  const [viewMode, setViewMode] = useState(() => {
    const saved = localStorage.getItem('eden-view-mode');
    if (saved) return saved;
    // Auto-detect mobile on first visit
    return window.innerWidth < 768 ? 'mobile' : 'desktop';
  });

  useEffect(() => {
    localStorage.setItem('eden-view-mode', viewMode);
    // Add/remove class on body for CSS hooks
    if (viewMode === 'mobile') {
      document.body.classList.add('mobile-mode');
      document.body.classList.remove('desktop-mode');
    } else {
      document.body.classList.add('desktop-mode');
      document.body.classList.remove('mobile-mode');
    }
  }, [viewMode]);

  const toggleViewMode = () => setViewMode(v => v === 'mobile' ? 'desktop' : 'mobile');
  const isMobile = viewMode === 'mobile';

  return (
    <ViewModeContext.Provider value={{ viewMode, setViewMode, toggleViewMode, isMobile }}>
      {children}
    </ViewModeContext.Provider>
  );
}

export function useViewMode() {
  const ctx = useContext(ViewModeContext);
  if (!ctx) throw new Error('useViewMode must be used within ViewModeProvider');
  return ctx;
}
